var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('div',{staticClass:"banner"},[_c('navComponent',{attrs:{"activeName":_vm.activeName}}),_c('bookNowBanner')],1),_c('bookNow'),_c('footerComponent')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }